module.exports = __webpack_public_path__ + "img/solar-panel.2696ed15.svg";